<template>
  <div class="flagWrap">
    <div class="wrap">
      <div
        class="flag"
        :style="{'background-color': statusObj.color}"
      >{{ statusObj.text }} </div>
      <div class="arrow" :style="{'border-top-color': statusObj.color}"></div>
    </div>
  </div>
</template>

<script>
import { statusKV } from "@/assets/js/status";

export default {
  name: "Status",
  props: ["status"],
  computed: {
    statusObj() {
      return statusKV[this.status] || {}
    }
  },
};
</script>

<style lang="stylus" scoped>
.flagWrap
  position absolute
  top 0
  left 0
  z-index 1000
  transform translateY(-15px)
  .wrap
    transform scale(0.875)
    .flag
      width 24px
      padding 2px 5px
      font-size 12px
      user-select none
    .arrow
      border-color transparent
      border-top 12px solid
      border-bottom 12px solid transparent
      border-left 12px solid transparent
      border-right 12px solid transparent
</style>